export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyAUwTkElrXTWto0kMHXfNf4vmqqDJx-TEs",
    authDomain: "pcrm-62139.firebaseapp.com",
    databaseURL: "https://pcrm-62139-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "pcrm-62139",
    storageBucket: "pcrm-62139.firebasestorage.app",
    messagingSenderId: "735315722068",
    appId: "1:735315722068:web:80d5fe37d6cfb2532992c1"
  },
  recaptchaSiteKey: '6LdYLEgsAAAAAB29Q_HnSahWRvznECGIPSl1pt3j',
  // App Check: Debug Token (Production - nur für Testing)
  appCheck: {
    enabled: true,
    debugToken: 'D6C22B3F-D8A6-4EB9-B1C2-90173CA25BC0' // Fester Debug Token für pos-terminal
  },
  useEmulators: false,
  encryption: {
    key: "YOUR_ENCRYPTION_KEY"
  },
};
